










import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class PicPreview extends Vue {
  @Prop()
  private picUrl: any;
  private scrollValue: any = 0;
  private picStyle() {
    const style: any = {};
    if (!this.$refs.pic) {
      return style;
    }
    style.width = (this.$refs.pic as any).offsetWidth + this.scrollValue + "px";
    return style;
  }
  /**
   * @description 监听鼠标滚轮放大缩小
   */
  private handleScroll(ev) {
    if (ev.deltaY > 0) {
      this.scrollValue = 100;
      this.$forceUpdate();
    } else {
      this.scrollValue = -100;
      this.$forceUpdate();
    }
  }
  /**
   * @description 关闭
   */
  private close() {
    this.$emit("close");
  }
  private mounted() {
    // chrome and ie
    window.addEventListener("mousewheel", this.handleScroll, false);
    // firefox
    window.addEventListener("DOMMouseScroll", this.handleScroll, false);
  }
}
